import projects from "../assets/projects.json";
import ProjectCard from "../components/ProjectCard";
import StarBackground from "../components/StarBackground";

function Projects() {
  return (
    <div className="w-full min-h-screen flex flex-col overflow-hidden relative projects-surface">
      <StarBackground />

      <div className="relative z-10 w-full px-4 sm:px-6 md:px-10 lg:px-16 pt-24 md:pt-28 pb-8 md:pb-10">
        <div className="max-w-6xl mx-auto">
          <header className="projects-header-card mb-6 md:mb-8">
            <p className="projects-kicker">Personal Projects</p>
            <h1 className="projects-title">Projects that showcase my technical level and product execution</h1>
            <p className="projects-subtitle">
              From mobile recommendation systems to full-stack web platforms, each project demonstrates concrete implementation choices and delivery focus.
            </p>
          </header>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 auto-rows-[200px] md:auto-rows-[220px] gap-4 md:gap-5">
            {projects.map((project, index) => (
              <div
                key={index}
                className={`${project.colSpan || ""} ${project.rowSpan || ""}`}
              >
                <ProjectCard
                  title={project.title}
                  description={project.description}
                  tech={project.tech}
                  link={project.link}
                  image={project.image}
                  type={project.type}
                  badge={project.badge}
                  imagePosition={project.imagePosition}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
